import { CrudFilter, useList } from '@refinedev/core';
import { Client } from '../../admin/users/types';

export const useClients = (
  filters: { advisorUserId?: string; familyId?: string; isTest?: boolean; companyId?: string } = {},
) => {
  const crudFilters: CrudFilter[] = [];

  if (filters.advisorUserId) {
    crudFilters.push({
      field: 'advisorUserId',
      operator: 'eq',
      value: filters.advisorUserId,
    });
  }

  if (filters.familyId) {
    crudFilters.push({
      field: 'familyId',
      operator: 'eq',
      value: filters.familyId,
    });
  }

  if (filters.isTest !== undefined) {
    crudFilters.push({
      field: 'isTest',
      operator: 'eq',
      value: filters.isTest,
    });
  }

  const { data, isLoading, isFetching, isError, refetch } = useList<Client>({
    resource: filters.companyId ? `admin/companies/${filters.companyId}/clients` : 'clients',
    filters: crudFilters,
  });

  return {
    clients: data?.data || [],
    isFetching,
    isLoading,
    isError,
    refetch,
  };
};
